// File: src/stores/auth.js
import { defineStore } from 'pinia';
import apiClient from '@/services/api.js';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null, // Data user (admin) yang sedang login
    token: localStorage.getItem('admin_token') || null,
  }),
  actions: {
    // Action untuk mengambil data user dari backend
    async fetchUser() {
      if (this.token && !this.user) { // Hanya fetch jika ada token dan data user belum ada
        try {
          const response = await apiClient.get('/admin/me');
          this.user = response.data;
        } catch (error) {
          console.error("Gagal mengambil data user:", error);
          this.logout(); // Jika token tidak valid, otomatis logout
        }
      }
    },
    // Action untuk logout
    logout() {
      this.user = null;
      this.token = null;
      localStorage.removeItem('admin_token');
    },
  },
});